module.exports = __webpack_public_path__ + "static/media/map.92fd312d.svg";